import { STAGE_META } from '../../lib/workflow';

const STEPS = [
  { k: 'new', label: 'Link', emoji: '🔗' },
  { k: 'in_visuals', label: 'Visuals', emoji: '🎨' },
  { k: 'in_review', label: 'Review', emoji: '👀' },
  { k: 'approved', label: 'Approved', emoji: '✅' },
  { k: 'live_on_etsy', label: 'Live on Etsy', emoji: '🛍️' },
  { k: 'done', label: 'All channels', emoji: '🎉' },
];
const INDEX = { new: 0, in_visuals: 1, changes_requested: 1, in_review: 2, approved: 3, live_on_etsy: 4, done: 5 };

export const WorkflowStepper = ({ stage }) => {
  const cur = INDEX[stage] ?? 0;
  const changes = stage === 'changes_requested';
  return (
    <ol className="flex items-center gap-1 overflow-x-auto pb-1" data-testid="workflow-stepper">
      {STEPS.map((s, i) => {
        const done = i < cur || stage === 'done';
        const active = i === cur && stage !== 'done';
        const emoji = active && changes ? '🔁' : s.emoji;
        const tone = active
          ? changes ? 'bg-[#FFE4E6] text-[#9F1239] border-[#FECDD3] ring-2 ring-[#FECDD3]' : 'bg-[#FDF0EC] text-[#C85A32] border-[#F6D5CB] ring-2 ring-[#F6D5CB]'
          : done ? 'bg-[#EBF5F0] text-[#2B6F52] border-[#C5E3D5]' : 'bg-white text-[#9A8E85] border-[#E8E1D5]';
        return (
          <li key={s.k} className="flex items-center gap-1 shrink-0" data-testid={`workflow-step-${s.k}`}>
            <span className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-[11px] font-bold transition-colors ${tone}`}>
              <span aria-hidden>{done && !active ? '✓' : emoji}</span>
              {active && changes ? STAGE_META.changes_requested.label : s.label}
            </span>
            {i < STEPS.length - 1 && <span className={`w-5 h-0.5 rounded ${i < cur ? 'bg-[#81B29A]' : 'bg-[#E8E1D5]'}`} />}
          </li>
        );
      })}
    </ol>
  );
};
